<form [formGroup]="form" autocomplete="off">

	<nav class="toolbar navbar navbar-light">
		<div class="form-inline">
			<button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
		</div>
	</nav>	

	<div class="animated fadeIn container-fluid">

		<div class="row">
			<!--DATOS PRE DUA-->
			<div class="col-md-12">
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedDatosPreDua = !isCollapsedDatosPreDua" [attr.aria-expanded]="!isCollapsedDatosPreDua" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Datos Pre DUA
							<i *ngIf="isCollapsedDatosPreDua" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedDatosPreDua" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">
						<div class="collapse group-filtros" id="collapsedDatosPreDua" [ngbCollapse]="isCollapsedDatosPreDua">
							<div class="row">

								<div class="form-group col-md-3">
									<label class="col-form-label" for="inpMrn">MRN</label>
									<input formControlName="Mrn" name="Mrn" readonly title="" class="form-control" id="inpMrn" type="text" value="" maxlength="18">
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="intOperacion">Operación</label>
									<ng-select [items]="listOperacion"
											   bindLabel="Descripcion"
											   bindValue="Id"
											   formControlName="IdOperacion"
											   loadingText="Cargando..."
											   [readonly]="!listOperacion || listOperacion.length === 0"
											   [loading]="!listOperacion || listOperacion.length === 0"
											   notFoundText="Operación no encontrada"
											   placeholder="-- Seleccione Operación --"
											   clearAllText="Eliminar selección">
									</ng-select>
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="inpMrn">Punto Inspección</label>
									<input formControlName="IdPifDescripcion" name="IdPifDescripcion" readonly title="" class="form-control" id="inpMrn" type="text" value="">
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="inpMrn">Aduana</label>
									<input formControlName="IdAduanaDespachoDescripcion" name="IdAduanaDespachoDescripcion" readonly title="" class="form-control" id="inpMrn" type="text" value="">
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">

			<div class="col-md-12">
				<!--EXPORTADOR-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedExportador = !isCollapsedExportador" [attr.aria-expanded]="!isCollapsedExportador" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Exportador
							<i *ngIf="isCollapsedExportador" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedExportador" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">
						<div class="collapse group-filtros" id="collapsedExportador" [ngbCollapse]="isCollapsedExportador">
							<div class="row">

								<div class="form-group col-md-6">
									<label class="col-form-label" for="inpDescripcion">Nombre</label>
									<input formControlName="NombreExportador" name="NombreExportador" readonly title="" class="form-control" id="inpNombreExportador" type="text" value="">
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="intEstado">País</label>
									<input formControlName="PaisExportador" name="PaisExportador" readonly title="" class="form-control" id="inpPaisExportador" type="text" value="">
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="inpDescripcion">Ciudad</label>
									<input formControlName="CiudadExportador" name="CiudadExportador" readonly title="" class="form-control" id="inpCiudad" type="text" value="">
								</div>

							</div>

							<div class="row">

								<div class="form-group col-md-12">
									<label class="col-form-label" for="inpDescripcion">Dirección</label>
									<input formControlName="DireccionExportador" name="DireccionExportador" readonly title="" class="form-control" id="inpDireccion" type="text" value="">
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<!--IMPORTADOR-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedImportador = !isCollapsedImportador" [attr.aria-expanded]="!isCollapsedImportador" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Importador
							<i *ngIf="isCollapsedImportador" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedImportador" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">
						<div class="collapse group-filtros" id="collapsedImportador" [ngbCollapse]="isCollapsedImportador">
							<div class="row">

								<div class="form-group col-md-6">
									<label class="col-form-label" for="inpDescripcion">Nombre</label>
									<input formControlName="RazonSocialImportador" name="RazonSocialImportador" readonly title="" class="form-control" id="inpRazonSocialImportador" type="text" value="">
								</div>
								<div class="form-group col-md-3">
									<label class="col-form-label" for="inpDescripcion">EORI/NIF</label>
									<input formControlName="IdentificadorImportador" name="IdentificadorImportador" readonly title="" class="form-control" id="" type="text" value="">
								</div>
							</div>

							<div class="row">

								<div class="form-group col-md-12">
									<label class="col-form-label" for="inpDescripcion">Dirección</label>
									<input formControlName="DireccionImportador" name="DireccionImportador" readonly title="" class="form-control" id="inpDireccionImportador" type="text" value="">
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<!--LUGARES REFERENTES A LA MERCANCIA-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedLugaresMercancia = !isCollapsedLugaresMercancia" [attr.aria-expanded]="!isCollapsedLugaresMercancia" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Lugar mercancía
							<i *ngIf="isCollapsedLugaresMercancia" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedLugaresMercancia" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">
						<div class="collapse group-filtros" id="collapsedLugaresMercancia" [ngbCollapse]="isCollapsedLugaresMercancia">
							<div class="row">
								<div class="form-group col-md-4">
									<label class="col-form-label" for="intPais">País de Origen</label>
									<input formControlName="PaisOrigen" name="PaisOrigen" readonly title="" class="form-control" id="inpPaisOrigen" type="text" value="">

								</div>

								<div class="form-group col-md-4">
									<label class="col-form-label" for="intPais">País de Destino</label>
									<input formControlName="PaisDestino" name="PaisDestino" readonly title="" class="form-control" id="inpPaisDestino" type="text" value="">

								</div>

								<div class="form-group col-md-4">
									<label class="col-form-label" for="">Transporte</label>
									<input formControlName="MedioTransporte" name="MedioTransporte" readonly title="" class="form-control" id="inpMedioTransporte" type="text" value="">

								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<!--OTROS DATOS-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedOtrosDatos = !isCollapsedOtrosDatos" [attr.aria-expanded]="!isCollapsedOtrosDatos" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Otros datos
							<i *ngIf="isCollapsedOtrosDatos" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedOtrosDatos" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">
						<div class="collapse group-filtros" id="collapsedOtrosDatos" [ngbCollapse]="isCollapsedOtrosDatos">
							<div class="row">

								<div class="form-group col-md-4" style="pointer-events:none">
									<label class="col-form-label" for="inpFecha">Fecha Creación</label>
									<p-calendar readonlyInput="true" formControlName="FechaCreacion" inputStyleClass="form-control"
												[showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

								</div>
								<div class="form-group col-md-4" style="pointer-events:none">
									<label class="col-form-label" for="inpFecha">Fecha Modificación</label>
									<p-calendar readonlyInput="true" formControlName="FechaModificacion" inputStyleClass="form-control"
												[showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

								</div>
								<div class="form-group col-md-4" style="pointer-events:none">
									<label class="col-form-label" for="inpFecha">Fecha Presentación</label>
									<p-calendar readonlyInput="true" formControlName="FechaPresentacion" inputStyleClass="form-control"
												[showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

								</div>

							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<!--PARTIDAS PRE DUA-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedPartidasPreDua = !isCollapsedPartidasPreDua" [attr.aria-expanded]="!isCollapsedPartidasPreDua" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Partidas Pre DUA
							<i *ngIf="isCollapsedPartidasPreDua" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedPartidasPreDua" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body">
						<div class="collapse group-filtros" id="collapsedPartidasPreDua" [ngbCollapse]="isCollapsedPartidasPreDua">

							<div class="row">
								<div class="col-md-12 scroll">

									<p-table #tableSearch autoLayout="true" [value]="partidas" dataKey="Id"
											 [columns]="selectedColumns" sortField="Partida"
											 styleClass="table table-responsive-sm table-striped table-sm"
											 rowExpandMode="single"
											 [ngClass]="displayGridHidden(partidas)">

										<ng-template pTemplate="header" let-columns>
											<tr>
												<th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
													{{col.header}}
													<p-sortIcon *ngIf="col.field!=='Link' && col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
												</th>
											</tr>
										</ng-template>
										<ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
											<tr>

												<td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
													<span *ngIf="(col.field!=='Peso' && col.field!=='Acumulado')">{{rowData[col.field]}}</span>
													<span *ngIf="col.field==='Peso'">{{rowData[col.field] | number:'1.3-3'}}</span>
													<span *ngIf="col.field==='Acumulado'">{{rowData[col.field] | number:'1.3-3'}}</span>
												</td>
											</tr>

										</ng-template>

									</p-table>

								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-4">
				<!--CONTENEDORES POSICIONADOS-->
				<div class="card card-accent-success animated fadeIn">
					<a class="card-header-a" (click)="isCollapsedContenedores = !isCollapsedContenedores" [attr.aria-expanded]="!isCollapsedContenedores" aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Contenedores posicionados
							<i *ngIf="isCollapsedContenedores" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedContenedores" class="fa fa-caret-up float-right"></i>
						</div>
					</a>

					<div class="card-body">
						<div class="collapse group-filtros" id="collapsedContenedores" [ngbCollapse]="isCollapsedContenedores">

							<div class="row">
								<div class="col-md-12 scroll">

									<table class="table table-responsive table-sm">
										<thead>
											<tr>
												<th>Matrícula</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of posicionamientopredua">
												<td>{{item.Matricula}}</td>
											</tr>
										</tbody>
									</table>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</form>
